import { render } from "./AdminPanelLogin.vue?vue&type=template&id=477d54bb&scoped=true"
import script from "./AdminPanelLogin.vue?vue&type=script&lang=js"
export * from "./AdminPanelLogin.vue?vue&type=script&lang=js"

import "./AdminPanelLogin.vue?vue&type=style&index=0&id=477d54bb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477d54bb"]])

export default __exports__